import { Stack, StackProps } from "@chakra-ui/react";

export interface TouchableOpacityType extends StackProps {
  disabled?: boolean;
}

const TouchableOpacity: React.FC<TouchableOpacityType> = ({
  disabled,
  ...props
}) => {
  if (disabled) {
    return (
      <Stack
        {...props}
        cursor={"not-allowed"}
        opacity={0.5}
        onClick={() => {}}
      />
    );
  }
  return (
    <Stack
      cursor={"pointer"}
      _hover={{ opacity: 0.8 }}
      _active={{ opacity: 0.3 }}
      {...props}
    />
  );
};

export default TouchableOpacity;
